import React, { FC, useState, useEffect } from 'react';
import {
  Divider,
  Box,
  Card,
  TableContainer,
  IconButton,
  Button,
  Tooltip,
  Chip
} from '@mui/material';
import {
  IServerFilter,
  ServerFilter
} from '../../../components/ServerFilter/ServerFilter';

import { API } from '../../../config/config';
import { useModalStore } from '../../../zustandStore/store.attributes';
import {
  ActionCell,
  DynamicTable
} from '../../../components/DynamicTable/DynamicTable';

import { useUpdateModalStore } from '../../../zustandStore/store.update';
import { AsyncImage } from '../../../components/AsyncImage/AsyncImage';
import { Swiper, SwiperSlide } from 'swiper/react';
import { descendingComparator } from '../../../Utils';
import { useAuth } from 'src/hooks/useAuth';
import { PrizeProducts, PrizetImageAPI } from 'src/interface/interface';
import { Navigation, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import LogoSpinner from 'src/components/LogoSpinner';
import { CreateProductForm } from './CreateProductForm';
import { EditProductForm } from './EditProductForm';
import toast from 'react-hot-toast';
import { FolderDelete, ZoomIn } from '@mui/icons-material';
import { toDateTime } from '../../../utils/payloadFormatter';
import { TagsDialog } from '../../../components/TagsDialog';
import { ProductsBulkUploadDialog } from './ProductsBulkUploadDialog';
import { ProductDetailDialog } from './ProductDetailDialog';
import { ArchiveDialog } from '../../../components/shared/ArchiveDialog';
import { AddCircle, Remove, RemoveCircle } from '@material-ui/icons';
import AddIcon from '@mui/icons-material/Add';

interface RecentOrdersTableProps {
  className?: string;
}

const ProductsContent: FC<RecentOrdersTableProps> = () => {
  const { enhancedFetch } = useAuth();
  const [tags, setTags] = useState([]);
  const [attribute, setAttribute] = useState([]);
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState<PrizeProducts[]>([]);
  const [reload, setReload] = useState(false);
  const state = useModalStore((state) => state);
  const [currentProduct, setCurrentProduct] = useState<any>(null);
  const updateState = useUpdateModalStore((state) => state);
  const action = state.actions;
  const [sortBy, SetSortBy] = useState<string>('id');
  const [sortAsc, setSortAsc] = useState<'asc' | 'desc'>('asc');
  const [showtag, setShowTag] = useState<boolean>(false);
  const [renderTags, setRenderTags] = useState<[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalProducts, setTotalProducts] = useState<number>(0);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [filterApplied, setFilterApplied] = useState<IServerFilter>(null);
  const [currentSearchQuery, setCurrentSearchQuery] = useState('');
  const [archiveModal, setArchiveModal] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<PrizeProducts>(null);

  const handleCreateProduct = (data: any) => {
    // Dump all the information
    enhancedFetch(`${API.HOST}/api/v1/products`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...data,
        productName: data?.productName,
        productDescription: data.productDescription,
        brandId: data?.brandId,
        published: data?.published,
        categories: [],
        images: data?.images?.map((image: any) => {
          return {
            image: image.image,
            placeholder: image.image,
            isThumbnail: image.is_thumbnail
          };
        }),
        tags: data?.tags?.map((tag: any) => tag.value),
        attributes: data?.attributes?.map((attribute: any) => {
          return {
            attributeId: attribute.attributeId,
            values: attribute.value
          };
        })
      })
    })
      .then((_) => {
        toast.success('Products created successfully!');
        action.setModal({ modalOpen: false });
        setReload(!reload);
      })
      .catch((error) => {
        // Personalized error messages
        let errorMsg = 'An error occurred. Please try again.';

        if (error.response && error.response.status) {
          // Handle different error status codes
          switch (error.response.status) {
            case 400:
              errorMsg =
                'The form contains invalid data. Please check your inputs.';
              break;
            case 401:
              errorMsg = 'Your session has expired. Please log in again.';
              break;
            // ... other error cases
            default:
              errorMsg =
                error.response.data?.message ||
                'An unexpected error occurred. Please try again.';
          }
        } else if (error.message) {
          if (error.message.includes('Network Error')) {
            errorMsg = 'Network error. Please check your internet connection.';
          } else if (error.message.includes('timeout')) {
            errorMsg = 'Request timed out. Please try again.';
          } else {
            errorMsg = error.message;
          }
        }

        toast.error(errorMsg);
      });
  };
  const handleUpdateProduct = (data: any) => {
    // Use the editEndpoint from deleteState.settings
    enhancedFetch(`${updateState.settings.editEndpoint}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...data,
        productName: data?.productName,
        slug: data?.slug,
        productDescription: data.productDescription,
        brandId: data?.brandId,
        published: data?.published,
        categories: [],
        images: data?.images?.map((image: any) => {
          return {
            image: image.image,
            placeholder: image.image,
            isThumbnail: image.is_thumbnail
          };
        }),
        tags: data?.tags?.map((tag: any) => tag.value),
        attributes: data?.attributes?.map((attribute: any) => {
          return {
            attributeId: attribute.attributeId,
            values: attribute.value
          };
        })
      })
    })
      .then((_) => {
        toast.success('Products updated successfully!');
        updateState.actions.setModal({ modalOpen: false, isEdit: false });
        setReload(!reload);
      })
      .catch((error) => {
        // Personalized error messages
        let errorMsg = 'An error occurred. Please try again.';

        if (error.response && error.response.status) {
          // Handle different error status codes
          switch (error.response.status) {
            case 400:
              errorMsg =
                'The form contains invalid data. Please check your inputs.';
              break;
            case 401:
              errorMsg = 'Your session has expired. Please log in again.';
              break;
            // ... other error cases
            default:
              errorMsg =
                error.response.data?.message ||
                'An unexpected error occurred. Please try again.';
          }
        } else if (error.message) {
          if (error.message.includes('Network Error')) {
            errorMsg = 'Network error. Please check your internet connection.';
          } else if (error.message.includes('timeout')) {
            errorMsg = 'Request timed out. Please try again.';
          } else {
            errorMsg = error.message;
          }
        }
        toast.error(errorMsg);
      });
  };

  useEffect(() => {
    enhancedFetch(`${API.HOST}/api/v1/attributes`, {
      // 1. Change the URL
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      if (Array.isArray(data)) {
        setAttribute(
          data?.map((attribute: any) => {
            return {
              value: attribute.id,
              label: attribute.name,
              attributeValues: attribute.attributeValues
            };
          })
        );
      } else {
        console.warn('API response data is not array');
      }
    });

    enhancedFetch(`${API.HOST}/api/v1/tags`, {
      // 1. Change the URL
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      if (Array.isArray(data)) {
        setTags(
          data?.map((attribute: any) => {
            return {
              id: attribute.id, // Change the Key and Value to map the response
              tagName: attribute.tagName
            };
          })
        );
      } else {
        console.warn('API response data is not array');
      }
    });

    enhancedFetch(`${API.HOST}/api/v1/brands`, {
      // 1. Change the URL
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      if (Array.isArray(data)) {
        setBrands(
          data?.map((attribute: any) => {
            return {
              value: attribute.id, // Change the Key and Value to map the response
              label: attribute.name
            };
          })
        );
      } else {
        console.warn('API response data is not array');
      }
    });
  }, [reload]);

  useEffect(() => {
    // PAGINATION API CALL FOR PRODUCTS HERE
    setIsLoading(true);
    enhancedFetch(
      `${API.HOST}/api/v1/products/search?page=${page}&size=${rowsPerPage}`,
      {
        // 1. Change the URL
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: currentSearchQuery,
          filter: filterApplied,
          sortBy: sortBy,
          sortAsc: sortAsc
        })
      }
    ).then((data) => {
      setProducts(
        data?.content?.map((product: PrizeProducts) => {
          return {
            id: product.id,
            slug: product.slug,
            productName: product.productName,
            productDescription: product.productDescription,
            brand: product.brand,
            updatedAt: product.updatedAt,
            galleries: product.galleries,
            productAttributes: product.productAttributes,
            published: product.published,
            tags: product.tags,
            status: product.status
          };
        })
      );
      setTotalProducts(data.totalElements);
      setIsLoading(false);
    });
  }, [page, rowsPerPage, reload]);

  // sorting logic
  useEffect(() => {
    const _products = [...products]?.sort((a, b) => {
      const dateA = new Date(a.updatedAt);
      const dateB = new Date(b.updatedAt);

      if (sortAsc === 'asc') {
        return descendingComparator(dateA.getTime(), dateB.getTime(), sortBy);
      }
      if (sortAsc === 'desc') {
        return -descendingComparator(dateA.getTime(), dateB.getTime(), sortBy);
      }
    });
    setProducts(_products);
  }, [sortBy, sortAsc]);

  const CreateProductFormDialog = CreateProductForm({
    fullWidth: false,
    isLoading: false,
    maxWidth: 'xl',
    onClose: () => {
      action.setModal({ modalOpen: false });
    },
    onSubmit: (data: any) => {
      handleCreateProduct(data);
    },
    openModal: state.settings.modalOpen,
    title: 'Create Products',
    data: {
      slug: null,
      productName: null,
      productDescription: null,
      brandId: null,
      published: undefined,
      images: [],
      tags: [],
      tagValues: [],
      attributeValues: [],
      brands: [],
      attribute
    }
  });

  const UpdateProductFormDialog = EditProductForm({
    maxWidth: 'xl',
    isLoading: false,
    onClose: () => {
      updateState.actions.setModal({ modalOpen: false, isEdit: false });
    },
    onSubmit: (data: any) => {
      handleUpdateProduct(data);
    },
    editData: updateState.settings.payload,
    openModal: updateState.settings.isEdit,
    title: 'Update Products',
    data: {
      productName: updateState.settings.payload?.productName,
      productDescription: updateState.settings.payload?.productDescription,
      brandId: updateState.settings.payload?.brand?.id,
      published: updateState.settings.payload?.published,
      images: updateState.settings.payload?.galleries,
      tags,
      tagValues: updateState.settings.payload?.tags,
      attributeValues: updateState.settings.payload?.productAttributes,
      brands,
      attribute
    }
  });

  return (
    <Card>
      <ArchiveDialog
        data={selectedProduct}
        id={selectedProduct?.id}
        open={archiveModal}
        endpoint={`${API.HOST}/api/v1/products/${selectedProduct?.id}/update/status`}
        onClose={() => {
          setArchiveModal(false);
        }}
        callback={() => {
          setReload(!reload);
        }}
      />
      <Divider />

      {/* Filter Bar Integrated within DynamicTable */}
      <ServerFilter
        filtersAction={setFilterApplied}
        onQueryChange={(query) => {
          setCurrentSearchQuery(query);
        }}
        hideProductName={true}
        setLoader={setIsLoading}
        endpoint={`${API.HOST}/api/v1/products/search`}
        onResultFetched={(data) => {
          setProducts(
            data?.content?.map((product: PrizeProducts) => {
              return {
                id: product.id,
                slug: product.slug,
                productName: product.productName,
                productDescription: product.productDescription,
                brand: product.brand,
                updatedAt: product.updatedAt,
                galleries: product.galleries,
                productAttributes: product.productAttributes,
                published: product.published,
                tags: product.tags,
                status: product.status
              };
            })
          );

          setTotalProducts(data.totalElements);
        }}
        products={products?.map((item) => ({
          id: item.id,
          title: item.productName
        }))}
      />

      {loading ? (
        <Box
          sx={{
            height: '400px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <LogoSpinner />
        </Box>
      ) : (
        <TableContainer>
          <DynamicTable
            showPagination={true}
            rowsPerPage={rowsPerPage}
            page={page}
            totalPage={totalProducts}
            sortByField={sortBy}
            onSort={(asc: 'desc' | 'asc') => {
              SetSortBy(asc);
              setSortAsc(asc);
            }}
            sort={sortAsc}
            rows={products?.map((product: any) => ({
              id: product.id,
              productName: product.productName,
              brand: product.brand.name,
              updatedAt: toDateTime(product.updatedAt),
              galleries: product.galleries,
              tags: product.tags,
              productAttributes: product.productAttributes,
              productDescription: product.productDescription,
              status: product.status
            }))}
            headers={[
              {
                headerName: 'Products Name',
                field: 'productName'
              },
              {
                headerName: 'Description',
                field: 'productDescription'
              },
              {
                headerName: 'Brand',
                field: 'brand'
              },
              {
                headerName: 'Status',
                field: 'status',
                renderCell: (value) => {
                  const colorScheme =
                    value.row.status === 'ACTIVE' ? 'primary' : 'error';
                  const icon =
                    value.row.status === 'ACTIVE' ? (
                      <RemoveCircle
                        style={{
                          color: 'white'
                        }}
                      />
                    ) : (
                      <AddCircle
                        style={{
                          color: 'white'
                        }}
                      />
                    );
                  return (
                    <>
                      <Tooltip
                        title={
                          value.row.status === 'ACTIVE'
                            ? 'Archive'
                            : 'Unarchive'
                        }
                        arrow
                      >
                        <Chip
                          deleteIcon={icon}
                          onDelete={(e) => void {}}
                          onClick={(e) => {
                            // Archive the product
                            setSelectedProduct(value.row);
                            setArchiveModal(true);
                          }}
                          color={colorScheme}
                          label={value?.row?.status}
                        />
                      </Tooltip>
                    </>
                  );
                }
              },
              {
                headerName: 'Tags',
                field: 'tags',
                renderCell: ({ row: product }) => {
                  return (
                    <Button
                      variant={'contained'}
                      type={'button'}
                      onClick={(e) => {
                        setShowTag(true);
                        setRenderTags(product?.tags);
                      }}
                    >
                      View Tags
                    </Button>
                  );
                }
              },
              {
                headerName: 'Updated',
                field: 'updatedAt'
              },
              {
                headerName: 'Galleries',
                field: 'galleries',
                renderCell: (value) => (
                  <Box
                    sx={{
                      width: '150px'
                    }}
                  >
                    <Swiper
                      modules={[Navigation, Scrollbar, A11y]}
                      pagination={{ clickable: true }}
                      slidesPerView={1}
                    >
                      {value.row.galleries?.map((galleryItem, galleryIndex) => (
                        <Box key={`idx-${galleryIndex}`}>
                          <SwiperSlide
                            key={`swiper-${galleryIndex}`}
                            style={{
                              width: '100%'
                            }}
                          >
                            <AsyncImage
                              w={150}
                              h={150}
                              url={galleryItem?.image}
                            />
                          </SwiperSlide>
                        </Box>
                      ))}
                    </Swiper>
                  </Box>
                )
              },
              {
                headerName: 'Actions',
                field: 'actions',
                renderCell: (value) => (
                  <>
                    <ActionCell
                      editEndpoint={`${API.HOST}/api/v1/products/${value.row.id}`}
                      payload={products.find(
                        (product) => product.id === value.row.id
                      )}
                      callback={() => setReload(!reload)}
                    >
                      <IconButton
                        onClick={(e) => {
                          setCurrentProduct(value.row as any);
                        }}
                        color="inherit"
                        size="small"
                      >
                        <ZoomIn fontSize="small" />
                      </IconButton>
                    </ActionCell>
                  </>
                )
              }
            ]}
            handleChangePage={(event, newPage) => setPage(newPage)}
            handleChangeRowsPerPage={(event) => setRowsPerPage(event)}
          />
        </TableContainer>
      )}

      <TagsDialog
        onClose={() => setCurrentProduct(null)}
        open={showtag}
        onToggleVisibility={setShowTag}
        tags={renderTags}
      />
      <ProductsBulkUploadDialog
        open={state.settings.bulkUpload}
        toggleVisibility={state.actions.setBulkUpload}
      />
      <ProductDetailDialog
        currentProduct={currentProduct}
        setCurrentProduct={setCurrentProduct}
      />
      {UpdateProductFormDialog}
      {CreateProductFormDialog}
    </Card>
  );
};

export default ProductsContent;
